import {TextButton} from "./TextButton";
import React from "react";
import {Box, Stack} from "@mui/material";

export interface StepNavigationProps {
    currentStep: number;
    steps: number;
    stepsTitles: string[];
    prevStep: () => void;
    nextStep: () => void;
}

export const StepNavigation: React.FC<StepNavigationProps> = ({
    currentStep,
    steps,
    stepsTitles,
    prevStep,
    nextStep,
}) => {
    if (!steps || steps <= 0) {
        return null;
    }

    return (
        <Stack direction="row" alignItems="center">
            <Box
                display="inline-flex"
                alignItems="center"
                alignContent="center"
                boxSizing="border-box"
                paddingRight="1rem"
            >
                {stepsTitles[currentStep - 1]}
            </Box>
            <TextButton id="back" icon="back" color="primary" onClick={prevStep} disabled={currentStep === 1}>
                {"Back"}
            </TextButton>
            <TextButton id="next" icon="next" color="primary" onClick={nextStep} disabled={steps === currentStep}>
                {"Next"}
            </TextButton>
        </Stack>
    );
};
